(() => {
  const ready = root => {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const gallery = section.querySelector('.gallery-track');
      const slides = [...section.querySelectorAll('.gallery-slide')];
      const thumbs = [...section.querySelectorAll('[data-slide]')];
      let index = 0;
      const updateGallery = value => {
        index = Math.max(0, Math.min(value, slides.length - 1));
        thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
        const count = section.querySelector('[data-gallery-count]');
        if (count) count.textContent = `${index + 1} / ${slides.length}`;
      };
      const go = (value, immediate = false) => {
        const next = (value + slides.length) % slides.length;
        gallery.scrollTo({ left: next * gallery.clientWidth, behavior: immediate || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        updateGallery(next);
        const thumb = thumbs[next];
        if (thumb) {
          const tray = section.querySelector('.thumbnails');
          if (matchMedia('(max-width:749px)').matches) tray.scrollTo({ left: thumb.offsetLeft - tray.offsetLeft - tray.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'smooth' });
          else tray.scrollTo({ top: thumb.offsetTop - tray.clientHeight / 2 + thumb.clientHeight / 2, behavior: 'smooth' });
        }
      };
      thumbs.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.slide))));
      section.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
      section.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
      gallery?.addEventListener('scroll', () => updateGallery(Math.round(gallery.scrollLeft / gallery.clientWidth)), { passive: true });
      gallery?.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      updateGallery(0);
      if (gallery) gallery.scrollLeft = 0;
      const variants = JSON.parse(section.querySelector('[data-variants]')?.textContent || '[]') || [];
      const form = section.querySelector('.product-form');
      const native = section.querySelector('[data-native-purchase]');
      let interacted = false;
      let previousId = String(form?.querySelector('[name="id"]')?.value || '');
      const activate = event => { if (event.target.closest('.purchase-area')) interacted = true; };
      section.addEventListener('pointerdown', activate, { passive: true });
      section.addEventListener('keydown', activate);
      const variantImage = variant => {
        const opts = (variant.options || [variant.option1, variant.option2, variant.option3]).join(' ').toLowerCase();
        const color = opts.includes('charcoal') || opts.includes('black') ? 'charcoal' : opts.includes('snow') || opts.includes('white') ? 'snow' : opts.includes('rose') || opts.includes('pink') ? 'rose' : null;
        if (!color) return;
        const filename = `${opts.includes('roller') ? 'roller' : 'hero'}-${color}.webp`;
        const at = slides.findIndex(slide => slide.dataset.asset === filename);
        if (at >= 0) go(at, true);
      };
      const applyVariant = (id, userAction = false) => {
        const variant = variants.find(v => String(v.id) === String(id));
        if (!variant) return;
        const changed = String(id) !== previousId;
        previousId = String(id);
        if (!changed && !userAction) return;
        if (interacted || userAction) variantImage(variant);
        const price = section.querySelector('[data-price]');
        const compare = section.querySelector('[data-compare]');
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: section.dataset.currency || 'USD' });
        if (price) price.textContent = formatter.format(variant.price / 100);
        if (compare) compare.textContent = variant.compare_at_price > variant.price ? formatter.format(variant.compare_at_price / 100) : '';
        if (!section.classList.contains('has-kaching')) {
          const button = form?.querySelector('[name="add"]');
          if (button) button.disabled = !variant.available;
          const label = section.querySelector('[data-add-label]');
          if (label) label.textContent = variant.available ? 'ADD TO CART' : 'Sold out';
        }
      };
      section.addEventListener('change', event => {
        if (event.target.matches('[name="id"]')) { interacted = true; applyVariant(event.target.value, true); }
      });
      ['variant:change', 'variant:changed', 'product:variant-change'].forEach(name => document.addEventListener(name, event => {
        const variant = event.detail?.variant || event.detail?.data?.variant;
        if (variant?.id && variants.some(v => String(v.id) === String(variant.id))) applyVariant(variant.id);
      }));
      const detectKaching = () => {
        const widget = section.querySelector('kaching-bundles-block, kaching-bundles, .kaching-bundles__block, .kaching-bundles-block');
        const active = !!widget && widget.getBoundingClientRect().height > 5;
        section.classList.toggle('has-kaching', active);
        if (native) native.hidden = active && section.dataset.hideNative === 'true';
      };
      const observer = new MutationObserver(detectKaching);
      observer.observe(section, { childList: true, subtree: true });
      detectKaching();
      setTimeout(detectKaching, 1500);
      setTimeout(detectKaching, 4000);
      const poll = setInterval(() => {
        if (!section.isConnected) { clearInterval(poll); observer.disconnect(); return; }
        const id = form?.querySelector('[name="id"]')?.value;
        if (id && String(id) !== previousId) applyVariant(id);
      }, 450);
      section.querySelector('[data-open-model]')?.addEventListener('click', () => section.querySelector('[data-model-dialog]')?.showModal());
      section.querySelectorAll('[data-zoom]').forEach(button => button.addEventListener('click', () => {
        const dialog = section.querySelector('[data-zoom-dialog]');
        dialog.querySelector('img').src = button.querySelector('img').src;
        dialog.showModal();
      }));
    });
    root.querySelectorAll('[data-lifestyle-carousel]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const track = section.querySelector('.lifestyle-track');
      const photos = [...track.querySelectorAll('img')];
      if (photos.length < 2) return;
      const controls = section.querySelector('.lifestyle-controls');
      const pauseButton = section.querySelector('[data-photo-pause]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const on = (target, name, handler, options = {}) => target.addEventListener(name, handler, { ...options, signal: controller.signal });
      const clones = [];
      const clonePhoto = photo => {
        const clone = photo.cloneNode(true);
        [...clone.attributes].filter(attr => attr.name.startsWith('data-shopify')).forEach(attr => clone.removeAttribute(attr.name));
        clone.setAttribute('aria-hidden', 'true');
        clone.alt = '';
        clones.push(clone);
        return clone;
      };
      track.prepend(...photos.map(clonePhoto));
      track.append(...photos.map(clonePhoto));
      let step = 0, anchor = 0, active = 0, settled = 0, resizeFrame = 0;
      let paused = reducedMotion.matches, inView = false, dragging = false;
      let pointerX = 0, pointerScroll = 0, nextAutoAt = Date.now() + 4000;
      const updatePause = () => {
        pauseButton.setAttribute('aria-label', paused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel);
        pauseButton.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      };
      const measure = () => {
        step = photos[1].offsetLeft - photos[0].offsetLeft;
        anchor = photos[0].offsetLeft - (parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0);
        track.scrollTo({ left: anchor + active * step, behavior: 'instant' });
      };
      const normalize = () => {
        if (dragging || !step) return;
        const raw = Math.round((track.scrollLeft - anchor) / step);
        active = ((raw % photos.length) + photos.length) % photos.length;
        if (raw !== active) track.scrollTo({ left: anchor + active * step, behavior: 'instant' });
      };
      const go = direction => {
        normalize();
        track.scrollTo({ left: anchor + (active + direction) * step, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        nextAutoAt = Date.now() + 4000;
      };
      on(track, 'scroll', () => {
        clearTimeout(settled);
        settled = setTimeout(normalize, 180);
      }, { passive: true });
      on(section.querySelector('[data-photo-prev]'), 'click', () => go(-1));
      on(section.querySelector('[data-photo-next]'), 'click', () => go(1));
      on(pauseButton, 'click', () => { paused = !paused; nextAutoAt = Date.now() + 4000; updatePause(); });
      on(track, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'ArrowRight' ? 1 : -1);
      });
      on(track, 'pointerdown', event => {
        nextAutoAt = Date.now() + 5000;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true; pointerX = event.clientX; pointerScroll = track.scrollLeft;
        track.classList.add('is-dragging'); track.setPointerCapture(event.pointerId);
        event.preventDefault();
      });
      on(track, 'pointermove', event => {
        if (dragging) track.scrollLeft = pointerScroll - (event.clientX - pointerX);
      });
      const finishDrag = () => {
        if (!dragging) return;
        dragging = false;
        const nearest = Math.round((track.scrollLeft - anchor) / step);
        track.classList.remove('is-dragging');
        track.scrollTo({ left: anchor + nearest * step, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        nextAutoAt = Date.now() + 5000;
      };
      on(track, 'pointerup', finishDrag); on(track, 'pointercancel', finishDrag); on(track, 'lostpointercapture', finishDrag);
      on(track, 'wheel', () => { nextAutoAt = Date.now() + 5000; }, { passive: true });
      on(reducedMotion, 'change', () => { paused = reducedMotion.matches; updatePause(); });
      on(window, 'resize', () => { cancelAnimationFrame(resizeFrame); resizeFrame = requestAnimationFrame(measure); }, { passive: true });
      const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; }, { threshold: 0.1 });
      observer.observe(track);
      const timer = setInterval(() => {
        if (!section.isConnected) { cleanup(); return; }
        if (!paused && inView && !dragging && !document.hidden && !section.matches(':hover, :focus-within') && Date.now() >= nextAutoAt) go(1);
      }, 500);
      const cleanup = () => {
        clearInterval(timer); clearTimeout(settled); cancelAnimationFrame(resizeFrame);
        observer.disconnect(); controller.abort(); clones.forEach(clone => clone.remove());
        delete section.dataset.initialized;
      };
      on(document, 'shopify:section:unload', event => { if (event.target.contains(section)) cleanup(); });
      updatePause(); controls.hidden = false; measure();
    });
    root.querySelectorAll('[data-tabs]').forEach(tabs => {
      if (tabs.dataset.initialized) return;
      tabs.dataset.initialized = 'true';
      const buttons = [...tabs.querySelectorAll('[data-tab]')];
      buttons.forEach((button, i) => {
        button.addEventListener('click', () => {
          buttons.forEach(b => b.setAttribute('aria-selected', String(b === button)));
          tabs.querySelectorAll('[data-panel]').forEach(p => p.hidden = p.dataset.panel !== button.dataset.tab);
        });
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const next = buttons[(i + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length];
          next.click(); next.focus();
        });
      });
    });
    root.querySelectorAll('.review-masonry').forEach(grid => {
      if (grid.dataset.initialized) return;
      grid.dataset.initialized = 'true';
      let frame = 0;
      const layout = () => {
        frame = 0;
        const cards = [...grid.querySelectorAll('.review-card')].filter(card => !card.hidden);
        const columns = window.innerWidth < 750 ? 1 : window.innerWidth <= 1100 ? 4 : 5;
        const gap = columns === 1 ? 20 : 16;
        const width = (grid.clientWidth - (columns - 1) * gap) / columns;
        grid.classList.add('is-laid-out');
        const heights = Array(columns).fill(0);
        cards.forEach((card, index) => {
          const column = index % columns;
          card.style.width = `${width}px`;
          card.style.transform = `translate(${column * (width + gap)}px, ${heights[column]}px)`;
          heights[column] += card.offsetHeight + gap;
        });
        grid.style.height = columns === 1 ? 'auto' : `${Math.max(...heights) - gap}px`;
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(layout); };
      grid.querySelectorAll('img').forEach(image => image.addEventListener('load', schedule));
      const observer = new MutationObserver(schedule);
      observer.observe(grid, { attributes: true, attributeFilter: ['hidden'], subtree: true });
      window.addEventListener('resize', schedule, { passive: true });
      document.fonts.ready.then(schedule);
      schedule();
    });
    root.querySelectorAll('.testimonials-section').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const track = section.querySelector('.testimonial-track');
      const buttons = [...section.querySelectorAll('[data-card-index]')];
      buttons.forEach(button => button.addEventListener('click', () => track.scrollTo({ left: Number(button.dataset.cardIndex) * track.clientWidth, behavior: 'smooth' })));
      track.addEventListener('scroll', () => buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === Math.round(track.scrollLeft / track.clientWidth)))), { passive: true });
    });
  };
  document.addEventListener('click', event => {
    const menu = event.target.closest('.menu-toggle');
    if (menu) {
      const expanded = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(expanded));
      document.getElementById('MobileMenu')?.classList.toggle('is-open', expanded);
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog')?.close();
    const videoButton = event.target.closest('[data-video]');
    if (videoButton) {
      const dialog = document.querySelector('[data-video-dialog]');
      const video = dialog.querySelector('video');
      video.src = videoButton.dataset.video;
      video.poster = videoButton.querySelector('img')?.src || '';
      dialog.showModal(); video.play().catch(() => {});
    }
    const more = event.target.closest('[data-more-reviews]');
    if (more) { more.closest('.reviews-section').querySelectorAll('[data-extra-review]').forEach(card => card.hidden = false); more.hidden = true; }
    const write = event.target.closest('[data-write-review]');
    if (write) write.closest('.reviews-section').querySelector('[data-review-dialog]')?.showModal();
    if (event.target.tagName === 'DIALOG') {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => { if (event.target.tagName === 'DIALOG') event.target.querySelectorAll('video').forEach(v => { v.pause(); v.removeAttribute('src'); v.load(); }); }, true);
  document.addEventListener('change', event => { if (event.target.matches('[data-localization]')) event.target.form?.submit(); });
  document.addEventListener('shopify:section:load', event => ready(event.target));
  ready(document);
})();
